import mixin from './mixin'
export default{
    mixins:[mixin],
    data(){
        return {
            formData: {
                orgRoleName: "MERCHANT", //MERCHANT FORWARDER WAREHOUSE,
                menuLabel:"fbb-web.appoint.customer_app_list",
                search: {
                    EQ_status: null
                }
            },
        }
    }
}